import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

// const {
//     withStyles,
//     AppBar,
//     Tabs,
//     Tab
// } = window['material-ui'];

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper,
    },
});

class TTabs2 extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        tabTitles: PropTypes.arrayOf(PropTypes.string),
        tabContents: PropTypes.arrayOf(PropTypes.any),
        classes: PropTypes.object.isRequired,
    };

    static defaultProps = {
        tabTitles: ["Tab 1", "Tab 2", "Tab 3"],
        tabContents: ["Content 1", "Content 2", "Content 3"],
        classes: {},
    };

    state = {
        value: 0,
    };

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    handleChange = (event, value) => {
        this.setState({ value });
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    renderTabTitles = () => {
        let arr = [];

        for (var i = 0; i < this.props.tabTitles.length; i++) {
            arr.push(
                <Tab
                    style={{ textTransform: "none" }}
                    label={this.props.tabTitles[i]}
                    key={i}
                />
            );
        }

        return arr;
    };

    renderTabContent = () => {
        return <div style={{ border: "1px solid #eeeeee" }}>{this.props.tabContents[this.state.value]}</div>;
    };

    render() {
        const { classes } = this.props;
        const { value } = this.state;

        return (
            <div className={classes.root}>
                <AppBar
                    position="static"
                    color="default"
                    style={{ marginBottom: 0 }}
                >
                    <Tabs
                        value={value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        scrollable
                        scrollButtons="auto"
                    >
                        {this.renderTabTitles()}
                    </Tabs>
                </AppBar>
                {this.renderTabContent()}
            </div>
        );
    }
}

export default withStyles(styles)(TTabs2);
